<template>
  <div v-if="enabled" :class="['dialog', {hiding}]">

    <div class="content">
      <header>{{title}}</header>
      <p>
        <slot></slot>
      </p>
      <div class="close">
        <i @click="close"></i>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * 弹窗
   */
  export default {
    name: "DialogView",

    model: {
      prop: 'enabled',
      event: 'change'
    },

    props: {
      enabled: Boolean,

      // 标题
      title: {
        type: String,
        require: false
      }
    },

    data() {
      return {
        hiding: false
      }
    },

    methods: {
      close() {
        this.hiding = true;
        setTimeout(() => {
          this.$emit('change', false);
          this.hiding = false;
        }, 500);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-bottom: 100px;
    animation: fadeIn .5s;
    z-index: 999;

    .content {
      position: relative;
      width: 630px;
      background: #FFFFFF;
      border-radius: 20px;
      animation: scaleIn .5s;
      box-sizing: border-box;
      padding: 60px 45px;

      header {
        height: 48px;
        font-size: 40px;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        text-align: center;
      }

      p {
        padding-top: 20px;
        font-size: 28px;
        color: #333333;
        line-height: 46px;
        text-align: justify;
      }

      .close {
        position: absolute;
        width: 100%;
        height: 70px;
        bottom: -110px;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0;

        i {
          width: 70px;
          height: 70px;
          background: url("../assets/close.png") no-repeat;
          background-size: 70px 70px;

          &:active {
            opacity: 0.5;
          }
        }
      }
    }

    &.hiding {
      animation: fadeOut .5s forwards;

      .content {
        animation: scaleOut .5s forwards;
      }
    }
  }
</style>